import { apiService } from './api.service';
import { ElectricConfig } from '../types';

class ElectricConfigService {
  async getAllElectricConfigs(): Promise<ElectricConfig[]> {
    return apiService.get<ElectricConfig[]>('/electric-config');
  }

  async getElectricConfigsByType(type: string): Promise<ElectricConfig[]> {
    return apiService.get<ElectricConfig[]>(`/electric-config?type=${type}`);
  }

  async getElectricConfigById(id: string): Promise<ElectricConfig> {
    return apiService.get<ElectricConfig>(`/electric-config/${id}`);
  }

  async createElectricConfig(electricConfigData: {
    type: string;
    value: string;
  }): Promise<ElectricConfig> {
    try {
      return await apiService.post<ElectricConfig>('/electric-config', electricConfigData);
    } catch (error) {
      throw new Error(`Failed to create electric configuration: ${error}`);
    }
  }
}

export const electricConfigService = new ElectricConfigService();